import React from 'react';
import '../styles/global.css';
import ThemeToggle from '../components/ThemeToggle';
import { motion } from 'framer-motion';


function Resources() {
  return (
    <div className="app">
      <header className="hero-header">
        <div className="container">
          <h1>Resources</h1>
        </div>
      </header>

      <main className="container">
        <section className="resources-section">
          <p className="resource-intro">These resources are provided for informational purposes only. We do not endorse specific treatments or practitioners. Please consult with healthcare professionals for medical advice.</p>
          
          <div className="resource-category">
            <h2>Educational Materials</h2>
            <div className="resources-grid">
              <div className="resource-card card">
                <h3>Understanding Alternative Approaches</h3>
                <p>A guide to researching and evaluating different treatment options for cancer.</p>
                <a href="#" className="resource-link">Read More</a>
              </div>
              
              <div className="resource-card card">
                <h3>Nutrition & Cancer</h3>
                <p>Evidence-based information on dietary approaches that may support cancer recovery and prevention.</p>
                <a href="#" className="resource-link">Read More</a>
              </div>
            </div>
          </div>
          
          <div className="resource-category">
            <h2>Finding Support</h2>
            <div className="resources-grid">
              <div className="resource-card card">
                <h3>Support Groups</h3>
                <p>Directory of online and in-person groups focused on alternative cancer treatment approaches.</p>
                <a href="#" className="resource-link">Find Groups</a>
              </div>
              
              <div className="resource-card card">
                <h3>Questions to Ask Your Doctor</h3>
                <p>Conversation starters for discussing alternative treatments with conventional medical providers.</p>
                <a href="#" className="resource-link">View Questions</a>
              </div>
            </div>
          </div>
        </section>
        <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.5 }}
      >
        <ThemeToggle />
      </motion.div>
      </main>

      <footer className="site-footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <p>© {new Date().getFullYear()} My Abnormal Story</p>
              <p className="footer-tagline">
                Sharing alternative cancer treatment journeys to inspire hope
              </p>
            </div>
            <div className="footer-links">
              <a href="/" className="admin-link">Home</a>
              <a href="/about" className="admin-link">About Us</a>
              <a href="/privacy" className="admin-link">Privacy</a>
              <a href="/admin-login" className="admin-link">Admin</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Resources;